import React, { Component } from 'react';
import { Button, Card, CardBody, CardGroup, Col, Container, Alert, InputGroup, Row } from 'reactstrap';
import { ValidationForm, TextInput } from "react-bootstrap4-form-validation";
import _ from "lodash";
import { Link, Redirect } from 'react-router-dom';
import Http from '../../../services/Http';
import apiPath from '../../../constants/apiPath';
import { adminLogin } from "../../../actions/index";
import { connect } from "react-redux";
import validator from "validator";
import logo from '../../../assets/img/brand/logo.png';
const mapStateToProps = state => {
  return { admin: state.admin };
};

const mapDispatchToProps = dispatch => {
  return {
    adminLogin: admin => dispatch(adminLogin(admin))
  };
};

class ForgotPassword extends Component {
  constructor(props) {
    super(props);
    this.formRef = React.createRef();
    this.state = {
      loading: false,
      immediate: true,
      setFocusOnError: true,
      clearInputOnReset: false,
      email: '',
      isMailSent: false
    }
  }

  handleChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value
    })
  }

  handleSubmit = (e, formData, inputs) => {
    e.preventDefault();
    this.sendForgotPassLink(formData);
  }

  resetForm = () => {
    let formRef = this.formRef.current;
    formRef.resetValidationState(this.state.clearInputOnReset);
  }

  async sendForgotPassLink(postData) {
    let path = apiPath.forgotPassword;

    if (!_.isEmpty(postData)) {
      this.setState({ loading: true });
      let options = {
        method: 'POST',
        headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
        body: JSON.stringify(postData)
      }
      let result = await Http(path, options);
      this.setState({ loading: false });
      if (result.ok) {
        if (result.status === 200) {

          let resultData = await result.json();
          if (resultData.success) {

            this.setState({ submitFormSuccess: resultData.msg, email: '', submitFormError: null });
            setTimeout(() => {
              this.setState({ submitFormSuccess: null });
            }, 5000);
            this.resetForm();
          } else {
            this.setState({ submitFormError: resultData.msg, submitFormSuccess: null });
            setTimeout(() => {
              this.setState({ submitFormError: null });
            }, 5000);
          }
        }
      } else {
        this.setState({ submitFormError: result.statusText, submitFormSuccess: null });
        setTimeout(() => {
          this.setState({ submitFormError: null });
        }, 5000);
      }
    }
  }

  responseError() {
    if (this.state.submitFormError) {
      return <Alert color="danger">
        {this.state.submitFormError}
      </Alert>
    } else {
      return null;
    }
  }

  responseSuccess() {
    if (this.state.submitFormSuccess) {
      return <Alert color="success">
        {this.state.submitFormSuccess}
      </Alert>
    } else {
      return null;
    }
  }

  showLoading() {
    if (this.state.loading) {
      return <i className="fa fa-spinner fa-spin"></i>
    }
  }

  render() {

    if (!_.isEmpty(this.props.admin)) {
      return <Redirect to='/dashboard' />
    }

    return (
      <div className="app flex-row align-items-center login-body"  style={{backgroundImage:"url('../assets/img/backgeound-bg.jpg')"}}>
        <Container>
          <Row className="justify-content-center">
            <Col md="6">
              <CardGroup>
                <Card className="forgot-password-card">
                  {this.responseError()} {this.responseSuccess()}
                  <CardBody className="p-0">
                    <ValidationForm onSubmit={this.handleSubmit} onErrorSubmit={this.handleErrorSubmit}
                      ref={this.formRef}
                      immediate={this.state.immediate}
                      setFocusOnError={this.state.setFocusOnError}
                      defaultErrorMessage={{ required: "Please enter something." }} >
                        <div className="logoouteradmin"><img src={logo} alt="Lavender Logo"/></div>
                        <div className="loginbox p-4">
                      <h1>Forgot Password</h1>
                      <p className="text-muted">Enter your email address </p>
                      <InputGroup className="mb-3">
                        <TextInput name="email" id="email" type="email"
                          validator={validator.isEmail}
                          errorMessage={{ validator: "Please enter a valid email" }}
                          value={this.state.email}
                          onChange={this.handleChange}
                          placeholder={"Email"}
                        />
                      </InputGroup>
                      <Row>
                        <Col xs="6">
                          <Button disabled={this.state.loading} color="primary" type={"submit"} className="px-4">Submit {this.showLoading()}</Button>
                        </Col>
                        <Col xs="6" className="text-right">
                          <Button tag={Link} to={"login"} color="link" className="px-0">Back to Login</Button>
                        </Col>
                      </Row>
                      </div>
                    </ValidationForm>
                  </CardBody>
                </Card>
              </CardGroup>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(ForgotPassword);
